export class IfcExpressionFunctionConfigException extends Error {
  constructor(message: string) {
    super(message);
  }
}
